
const typography: any = {
    fontFamily: [
        'Gantari', 'sans-serif'
    ].join(','),
    fontSize: 14,
    sidebar: {
        main: 15,
    },
    
    button: {
        textTransform: 'none'
    },
    //text
    subtitle1: {
        fontSize: 16,
        fontWeight: 600,
      },
};

export default typography;